import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

/**
 * Points at the same `rclcommentcards` Firebase project as the original
 * comment-cards app, so sign-in, Firestore, and secrets are shared.
 *
 * These values are not secrets — Firebase web config is public by design, and
 * access is enforced by Firestore rules and App Check, not by hiding the keys.
 *
 * NOTE: messagingSenderId/appId are the placeholder values carried over from
 * the original app. Auth and Firestore do not use them; set the real ones from
 * the Firebase console if Analytics or FCM is ever turned on.
 */
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? 'AIzaSyCbj3Q-hKbp-wU8WoRNUD_4phsv1COmnsw',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? 'rclcommentcards.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'rclcommentcards',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? 'rclcommentcards.appspot.com',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '123456789012',
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '1:123456789012:web:abcdef1234567890abcdef',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);

/** Base URL for the Cloud Functions HTTP endpoints. */
export const FUNCTIONS_BASE =
  import.meta.env.VITE_FUNCTIONS_BASE ??
  `https://us-central1-${firebaseConfig.projectId}.cloudfunctions.net`;

export default app;
